<template>
  <div class="wrapper">
    <h2>My Account</h2>

    <el-card>
      <el-row id="account-profile" :gutter="24">
        <el-col :span="10">
          <el-form
            label-position="top"
            ref="profile"
            :model="form"
            :rules="rules"
          >
            <el-form-item label="First Name" prop="firstName">
              <el-input v-if="edit" v-model="form.firstName" />
              <template v-else>{{ user.firstName }}</template>
            </el-form-item>

            <el-form-item label="Last Name" prop="lastName">
              <el-input v-if="edit" v-model="form.lastName" />
              <template v-else>{{ user.lastName }}</template>
            </el-form-item>

            <el-form-item label="Email">
              <el-input v-if="edit" :value="user.email" :disabled="true" />
              <template v-else>{{ user.email }}</template>
            </el-form-item>

            <el-form-item label="Company">
              <el-input v-if="edit" v-model="form.company" />
              <span v-else-if="!user.company" class="gray">You haven't fill this information</span>
              <template v-else>{{ user.company }}</template>
            </el-form-item>

            <el-form-item label="Phone Number*">
              <el-input v-if="edit" v-model="form.phone" />
              <span v-else-if="!user.phone" class="gray">You haven't fill this information</span>
              <template v-else>{{ user.phone }}</template>
            </el-form-item>

            <el-form-item label="Registration date">
              {{ toCalendar(user.created) }}
            </el-form-item>

            <el-button
              :loading="loading"
              :type="edit ? 'primary' : 'info'"
              @click.prevent="update"
            >
              Update my information
            </el-button>
          </el-form>
        </el-col>

        <el-col v-if="client" :span="14">
          <template v-if="permission('owner')">
            <Product :user="user" :client="client" />

            <div class="account-actions">
              <el-button type="text" size="mini">Close account</el-button>
              Account <el-tag size="mini" type="info">{{ accountName(client) }}</el-tag>
            </div>
          </template>

          <el-alert
            v-else
            type="info"
            title="You are connected on the project of another account"
            :closable="false"
            show-icon
          />

        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Product from '../components/Account/Product'

export default {
  components: {
    Product
  },
  computed: {
    ...mapState(['client', 'user']),
    ...mapGetters(['permission'])
  },
  data () {
    return {
      loading: false,
      edit: false,
      localTab: this.tab,
      form: {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        company: this.user.company,
        phone: this.user.phone
      },
      rules: {
        firstName: [{ required: true, message: 'Please input your first name', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Please input your last name', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
    update () {
      if (this.edit) {
        return this.$refs.profile.validate((valid) => {
          if (valid) {
            this.loading = true
            this.$store.dispatch('updateUser', this.form)
              .then(() => {
                this.loading = false
                this.edit = false
              })
          }
        })
      }
      this.edit = true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  #account-profile {
    margin-top: 24px;

    .gray {
      color: $--color-text-gray;
    }
  }

  .account-actions {
    margin-top: 15px;
    color: $--color-text-gray;
    font-size: 12px;

    .el-button--text {
      float: right;
      color: $--color-danger;
    }
  }
</style>

<style lang="scss">
  @import "../theme";

  #account-profile {
    .el-form-item__label {
      color: $--color-primary;
      padding-bottom: 0;
      line-height: 24px;

      &:before {
        display: none;
      }
    }
  }
</style>
